var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPurpleShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 155 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_3_18490)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.7218,
    cy: 18.2068,
    r: 17.241,
    fill: "#9C00FC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.7238,
    cy: 13.5372,
    rx: 3.59187,
    ry: 3.59188,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.7228,
    cy: 22.8761,
    rx: 7.18374,
    ry: 3.59188,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_3_18490",
    x: 0.512077,
    y: 0.96582,
    width: 154.42,
    height: 171.661,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.49668
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.35793
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454902 0 0 0 0 0.0980392 0 0 0 0 0.807843 0 0 0 0.11846 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_18490"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.66786
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75451
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454902 0 0 0 0 0.0980392 0 0 0 0 0.807843 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3_18490",
    result: "effect2_dropShadow_3_18490"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 23.2765
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.03941
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454902 0 0 0 0 0.0980392 0 0 0 0 0.807843 0 0 0 0.22154 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_3_18490",
    result: "effect3_dropShadow_3_18490"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 77.2098
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29.9844
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454902 0 0 0 0 0.0980392 0 0 0 0 0.807843 0 0 0 0.34 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_3_18490",
    result: "effect4_dropShadow_3_18490"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_3_18490",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPurpleShadow);
export default __webpack_public_path__ + "static/media/user_purple_shadow.20fda8592cf16ed5ba2c412cfb930033.svg";
export { ForwardRef as ReactComponent };